"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DynamicElement = exports.ElementType = void 0;
const serialization_1 = require("./serialization");
const _ = __importStar(require("lodash"));
var ElementType;
(function (ElementType) {
    ElementType["STRING"] = "STRING";
    ElementType["NUMBER"] = "NUMBER";
    ElementType["BOOLEAN"] = "BOOLEAN";
    ElementType["DATE"] = "DATE";
    ElementType["OBJECT"] = "OBJECT";
    ElementType["EMAIL"] = "EMAIL";
})(ElementType = exports.ElementType || (exports.ElementType = {}));
const CURRENT_VERSION = 1;
class DynamicElement {
    constructor(source, target, valueSet, transformations, metadata, logic, pii) {
        this.source = source;
        this.target = target;
        this.valueSet = valueSet;
        this.transformations = transformations;
        this.metadata = metadata;
        this.logic = logic;
        this.pii = pii !== null && pii !== void 0 ? pii : false;
    }
    /**
     * Serialize the element to a JSON object that can be saved and later used to instantiate a new element by calling the constructor
     */
    serialize() {
        const ser = {
            version: CURRENT_VERSION,
            source: this.source,
            target: this.target,
            valueSet: this.valueSet,
            metadata: this.metadata,
            transformations: this.transformations,
            logic: this.logic,
            pii: this.pii
        };
        // Defensive copy - so that changes to the returned value won't affect this instance.
        return _.cloneDeep(ser);
    }
    static deserialize(serializedDynamicElement, logger) {
        // Defensive copy, so that future changes to de from the outside won't affect the returned instance.
        const de = _.cloneDeep(serializedDynamicElement);
        let version = de.version;
        if (!version) {
            throw (0, serialization_1.createSerializationErrorAndLog)("Missing version field in serialized data element", de, undefined, logger);
        }
        return new DynamicElement(de.source, de.target, de.valueSet, de.transformations, de.metadata, de.logic, de.pii);
    }
}
exports.DynamicElement = DynamicElement;
/*

function useInClient(element: DynamicElement) {
    const react: any = {};

    // Assuming we don't support mapping yet:
    react.name = element.source.name;
    react.valueSet = element.source.valueSet;

    // Assuming we now support mapping:
    react.sourceName = element.source.name;
    react.targetName = element.target.name;
    react.valueSet = element.source.valueSet;

    // Set the order of the element in the UI connector screen.
    react.order = element.metadata.order;

}

function useForStory(element: DynamicElement) {
    const rules: Array<any> = [];

    rules.push({
        when: `exists(stringDe('${element.target.name}'))`,
        value: `Hello [[stringDe('${element.target.name}')]]`,
        key: "ea7083d8-1653-4d44-ad57-b33428184643"
    });
    rules.push({
        value: "Fallback"
    });
}

function useInDragon(element: DynamicElement, feedData: any, runtimeElements: any) {

    let curValue = feedData[element.source.name];
    if (curValue === undefined) {
        delete runtimeElements[element.target.name];
    }
    else {
        for (const transform of element.transformations) {
            curValue = element.applyTransformation(transform, curValue);
        }

        runtimeElements[element.target.name] = curValue;
    }
}*/
//# sourceMappingURL=dynamicElement.js.map